import { render } from "./ModalLiveUri.vue?vue&type=template&id=7b9d0989&scoped=true"
import script from "./ModalLiveUri.vue?vue&type=script&lang=js"
export * from "./ModalLiveUri.vue?vue&type=script&lang=js"

import "./ModalLiveUri.vue?vue&type=style&index=0&id=7b9d0989&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b9d0989"]])

export default __exports__